import {ROOT_DIR} from "../../App";
import categories from "../../data/categories.json";
import countries from "../../data/countries.json";

function cleanStringForLink(string) {
    return string.replaceAll("-", "_").replaceAll("é", "e")
        .replaceAll("'", "").replaceAll("è", "e")
        .replaceAll(" / ", " et ").replaceAll("/", " et ")
        .replaceAll("â", "a").replaceAll("à", "a")
        .replaceAll(" ", "-").replaceAll("ô", "o")
        .replaceAll("'", "").replaceAll("’", "")
        .replaceAll("ë", "e");
}

export function getLink(property, isPromotion = false, fromPromotion = null) {
    return `${ROOT_DIR}${getRelativeUrl(property, isPromotion, fromPromotion)}`;
}

export function getRelativeUrl(property, isPromotion = false, fromPromotion = null) {
    return (`/${property.type === "buy" ? "vente" : "location"}` +
        (isPromotion ? "/promotions" : `/${cleanStringForLink(categories.find(category => category.name === property.categories[0].name)?.value)}`) +
        `/${cleanStringForLink(property.locality)}-${property.postalCode}` +
        (fromPromotion !== null ? `/${fromPromotion}` : "") +
        `/${property.ref}`)
        .toLowerCase();
}

export function getCityName(city, postalCode, loading) {
    const cities = JSON.parse(localStorage.getItem("cities"))?.data;

    return (loading || !cities.find((dataCity) => dataCity.postalCode === postalCode) ?
        city.charAt(0).toUpperCase() + city.slice(1)
        : cities.find((dataCity) => dataCity.postalCode === postalCode)?.name)
}

export function getCountryName(code) {
    const country = countries.find(country => country.code === code);

    return country ? country.name : "";
}